import CreditCard from '../payment/credit-card.vue'
import BankAccount from '../payment/bank-account.vue'
import Sales from '../../../services/sales'
import * as _ from 'lodash';

const typeOptions = [{caption: "Débito em conta", value: "DC"}, {caption: "Cartão de crédito", value: "CC"}]

export default {
  props: ['payment', 'planId', 'addressMailing', 'creditCardOptions', 'bankAccountOptions', 'bankBillOption', 'tedOption', 'docOption'],
  data() {
    return {
        address: undefined,
        loading: undefined,
        creditCard: undefined,
        bankAccount: undefined,
        itemSelected: undefined,
        valueCard: undefined,
        valueBank: undefined,
        type: undefined,
        typeOptions: typeOptions,
        creditAddress: undefined,
        addressStart: undefined
    }
  },

  created(){
    //se o cartao ainda nao tiver endereco copia o endereco de entrega
    if(!(this.creditCard && this.creditCard.billingAddress)){
      this.addressStart = _.cloneDeep(this.addressMailing);
    }

    if(this.payment.creditCard)
      this.type = 'CC'
    else if(this.payment.bankAccount)
      this.type = 'DC'
    else if(this.payment.bankBill)
      this.type = 'BC'
    else if(this.payment.ted)
      this.type = 'TE'
    else if(this.payment.doc)
      this.type = 'DO'
    else{
      if(this.bankAccountOptions && this.bankAccountOptions.length)
        this.type = 'DC'
      else if(this.creditCardOptions && this.creditCardOptions.length)
        this.type = 'CC'
      else
        this.type = 'BC'
    }

    this.$watch('bankAccount', () => {
      delete this.payment.bankBill;
      delete this.payment.creditCard;
      this.payment.bankAccount = this.bankAccount;
      this.payment.paymentMethodId = this.bankAccount.paymentMethodId;
      this.payment.imagePath = this.bankAccount.imagePath;
      this.payment.validForm = this.bankAccount.validForm;
    }, { deep: true });

    this.$watch('creditCard', () => {
      delete this.payment.bankBill;
      delete this.payment.bankAccount;
      this.payment.paymentMethodId = this.creditCard.paymentMethodId;
      this.payment.creditCard = this.creditCard;
      this.payment.imagePath = this.creditCard.imagePath;
      this.payment.validForm = this.creditCard.validForm;
    }, { deep: true });

  },

  computed: {
    bankIdSelected(){
      return this.bankAccount && this.bankAccount.paymentMethodId || this.bankAccountOptions[0] && this.bankAccountOptions[0].value;
    },
    cardIdSelected(){
      return this.creditCard && this.creditCard.paymentMethodId || this.creditCardOptions[0] && this.creditCardOptions[0].value;
    },
    typesAllowed(){
      return this.$store.getters.getPaymentsTypesByPlan(this.planId);
    },
    colClassPayment(){
      if(this.typesAllowed){
        let c = parseInt(12 / this.typesAllowed.qtd);
        return 'col-md-' + c;
      }
      return 'col-md-4';
    }
  },

  watch:{
    type(newValue){
      delete this.payment.bankBill;
      delete this.payment.bankAccount;
      delete this.payment.creditCard;
      if(newValue == 'BC'){
        this.payment.paymentMethodId = this.bankBillOption.paymentMethodId;
        this.payment.imagePath = this.bankBillOption.imagePath;
        this.payment.type = this.bankBillOption.type;
        this.payment.name = this.bankBillOption.name;
        this.payment.bankBill = {
            billNumber: this.bankBillOption.paymentMethodId,
            imagePath: this.bankBillOption.imagePath
        };
        this.payment.validForm = true;
      } else if(newValue == 'DC'){
        this.payment.bankAccount = this.bankAccount;
        this.payment.validForm = this.bankAccount.validForm;
        this.payment.paymentMethodId = this.bankAccount.paymentMethodId;

      } else if(newValue == 'CC'){
        this.payment.creditCard = this.creditCard;
        this.payment.validForm = this.creditCard && this.creditCard.validForm;
        this.payment.paymentMethodId = this.creditCard && this.creditCard.paymentMethodId;
      } else if(newValue == 'TE'){
        this.payment.paymentMethodId = this.tedOption.paymentMethodId;
        this.payment.imagePath = this.tedOption.imagePath;
        this.payment.type = 'TE';
        this.payment.name = 'TED';
        this.payment.bankBill = {
            billNumber: this.tedOption.paymentMethodId,
            imagePath: this.tedOption.imagePath
        };
        this.payment.validForm = true;
      } else if(newValue == 'DO'){
        this.payment.paymentMethodId = this.docOption.paymentMethodId;
        this.payment.imagePath = this.docOption.imagePath;
        this.payment.type = 'DO';
        this.payment.name = 'DOC';
        this.payment.bankBill = {
            billNumber: this.docOption.paymentMethodId,
            imagePath: this.docOption.imagePath
        };
        this.payment.validForm = true;
      }

    }
  },

  methods: {
    validateAll(){
      if(this.type == 'BC')
        return Promise.resolve(true);
      else if(this.type == 'CC')
        return this.$refs.creditCard.validateAll();
      else if(this.type == 'DC')
        return this.$refs.bankAccount.$validator.validateAll();
      else if(this.type == 'TE')
        return Promise.resolve(true);
      else if(this.type == 'DO')
        return Promise.resolve(true);

      return Promise.reject();
    }

  },

  components: {CreditCard, BankAccount}
}



// WEBPACK FOOTER //
// ./src/pages/common/adhesion/payment.js